import script from "./DefSKUSizes.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefSKUSizes.vue?vue&type=script&lang=ts&setup=true"

import "./DefSKUSizes.vue?vue&type=style&index=0&id=6ffbd9c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffbd9c6"]])

export default __exports__